import { Stack, Redirect } from "expo-router";
import { useAuth } from "@/context/AuthContext";
import type { UserRole } from "@chinese-vendor/schemas";

const STAFF_ROLES: UserRole[] = ["staff", "admin", "super_admin", "localization_staff"];

export default function StaffLayout() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) return null;

  if (!isAuthenticated || !user) {
    return <Redirect href="/(auth)/login" />;
  }

  if (user.temporaryPasswordSet) {
    return <Redirect href="/(auth)/change-password" />;
  }

  const isStaff = user.roles.some((r) => STAFF_ROLES.includes(r));
  if (!isStaff) {
    return <Redirect href="/(auth)/login" />;
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    />
  );
}
